export const model = {
    fields: {
        name: {
            isRequired: true
        },
        sampleCardId: {
            isRequired: true
        }
    }
}